// PageHeader — the standard "title + sub + actions" row at the top of every admin page.
//
// Per shell-strings.md §"Page header pattern":
//   - Title: 32px, 700, -0.025em
//   - Sub: 14px, --ink3, max ~620px
//   - Actions (right): secondary button(s) + one primary
//
// The page owns the strings; this is layout only.

import type { ReactNode } from 'react';
import styles from './PageHeader.module.css';

export interface PageHeaderProps {
  title: string;
  /** Optional subtitle paragraph below the title. */
  sub?: string;
  /** Right-aligned actions slot — buttons, links, etc. */
  actions?: ReactNode;
}

export function PageHeader({ title, sub, actions }: PageHeaderProps) {
  return (
    <header className={styles.header}>
      <div className={styles.text}>
        <h1 className={styles.title}>{title}</h1>
        {sub && <p className={styles.sub}>{sub}</p>}
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </header>
  );
}
